import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { OperatorsAlertTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const fetchOperatorsAlertsLoading = (state) => {
  return {
    ...state,
    fetchOperatorsAlertsRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorsAlertsLoadingMore = (state) => {
  return {
    ...state,
    fetchOperatorsAlertsRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchOperatorsAlertsSuccess = (
  state,
  { offset, alerts, nextOffset },
) => {
  let result = []
  for (let j = 0; j < alerts.length; j++) {
    if (!state.operatorsAlerts.some((alert) => alert._id === alerts[j]._id)) {
      result.push(alerts[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      fetchOperatorsAlertsRequestState: RequestState.SUCCEEDED,
      operatorsAlertsPaginationOffset: nextOffset,
      operatorsAlerts: [...result],
    }
  } else {
    return {
      ...state,
      fetchOperatorsAlertsRequestState: RequestState.SUCCEEDED,
      operatorsAlertsPaginationOffset: nextOffset,
      operatorsAlerts: [...state.operatorsAlerts, ...result],
    }
  }
}
export const fetchOperatorsAlertsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorsAlertsRequestState: requestState,
  }
}

export const setClickedOperatorAlert = (state, { rowData }) => {
  let selected
  if (rowData)
    selected = state.operatorsAlerts.find((alert) => alert._id === rowData._id)
  return {
    ...state,
    clickedOperatorAlert: selected || {},
  }
}

export const fetchAlertChargePointsLoading = (state) => {
  return {
    ...state,
    fetchAlertChargePointsRequestState: RequestState.LOADING,
  }
}
export const fetchAlertChargePointsLoadingMore = (state) => {
  return {
    ...state,
    fetchAlertChargePointsRequestState: RequestState.LOADING_MORE,
  }
}
export const fetchAlertChargePointsSuccess = (
  state,
  { offset, chargePoints, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchAlertChargePointsRequestState: RequestState.SUCCEEDED,
      alertChargePointsPaginationOffset: nextOffset,
      alertChargePoints: chargePoints ?? [],
    }
  } else {
    return {
      ...state,
      fetchAlertChargePointsRequestState: RequestState.SUCCEEDED,
      alertChargePointsPaginationOffset: nextOffset,
      alertChargePoints: [...state.alertChargePoints, ...(chargePoints ?? [])],
    }
  }
}

export const fetchAlertChargePointsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAlertChargePointsRequestState: requestState,
  }
}
export const setOperatorAlertFilter = (state, { filter }) => {
  return {
    ...state,
    operatorAlertFilter: filter,
  }
}
export const setAlertChargePointsFilter = (state, { filter }) => {
  return {
    ...state,
    alertChargePointsFilter: filter,
  }
}
export const resetAlertChargePoints = (state) => {
  return {
    ...state,
    alertChargePoints: [],
    alertChargePointsPaginationOffset: 0,
    fetchAlertChargePointsRequestState: RequestState.UNINITIALIZED,
  }
}
export const fetchOperatorsAlertsCountLoading = (state) => {
  return {
    ...state,
    fetchAlertCountRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorsAlertsCountSuccess = (state, { count }) => {
  return {
    ...state,
    fetchAlertCountRequestState: RequestState.SUCCEEDED,
    alertCount: count,
  }
}
export const fetchOperatorsAlertsCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAlertCountRequestState: requestState,
  }
}
export const editAlertLoading = (state) => {
  return {
    ...state,
    editAlertRequestState: RequestState.LOADING,
  }
}
export const editAlertSuccess = (state, { alert }) => {
  const updatedAlerts = state.operatorsAlerts.map((existingAlert) =>
    existingAlert._id === alert._id ? alert : existingAlert,
  )
  return {
    ...state,
    operatorsAlerts: updatedAlerts,
    editAlertRequestState: RequestState.SUCCEEDED,
    clickedOperatorAlert: alert,
  }
}
export const editAlertFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    editAlertRequestState: requestState,
  }
}
export const deleteAlertLoading = (state) => {
  return {
    ...state,
    deleteAlertRequestState: RequestState.LOADING,
  }
}
export const deleteAlertSuccess = (state, { alertId }) => {
  const updatedAlerts = state.operatorsAlerts.filter(
    (alert) => alert._id !== alertId,
  )
  return {
    ...state,
    operatorsAlerts: updatedAlerts,
    deleteAlertRequestState: RequestState.SUCCEEDED,
    clickedOperatorAlert: {},
    alertCount: state.alertCount > 0 ? state.alertCount - 1 : 0,
  }
}
export const deleteAlertFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteAlertRequestState: requestState,
  }
}
export const createAlertLoading = (state) => {
  return {
    ...state,
    createAlertRequestState: RequestState.LOADING,
  }
}
export const createAlertSuccess = (state, { alert }) => {
  return {
    ...state,
    operatorsAlerts: [alert, ...state.operatorsAlerts],
    createAlertRequestState: RequestState.SUCCEEDED,
    alertCount: state.alertCount + 1,
  }
}
export const createAlertFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createAlertRequestState: requestState,
  }
}
export const clearOperatorAlerts = (state) => {
  return {
    ...state,
    operatorsAlerts: [],
    operatorsAlertsPaginationOffset: 0,
    fetchOperatorsAlertsRequestState: RequestState.UNINITIALIZED,
  }
}
export const resetEditingStates = (state) => {
  return {
    ...state,
    editAlertRequestState: RequestState.UNINITIALIZED,
    deleteAlertRequestState: RequestState.UNINITIALIZED,
    createAlertRequestState: RequestState.UNINITIALIZED,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_LOADING]:
    fetchOperatorsAlertsLoading,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_LOADING_MORE]:
    fetchOperatorsAlertsLoadingMore,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_SUCCESS]:
    fetchOperatorsAlertsSuccess,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_FAIL]: fetchOperatorsAlertsFail,
  [OperatorsAlertTypes.SET_CLICKED_OPERATOR_ALERT]: setClickedOperatorAlert,
  [OperatorsAlertTypes.FETCH_ALERT_CHARGE_POINTS_LOADING]:
    fetchAlertChargePointsLoading,
  [OperatorsAlertTypes.FETCH_ALERT_CHARGE_POINTS_LOADING_MORE]:
    fetchAlertChargePointsLoadingMore,
  [OperatorsAlertTypes.FETCH_ALERT_CHARGE_POINTS_SUCCESS]:
    fetchAlertChargePointsSuccess,
  [OperatorsAlertTypes.FETCH_ALERT_CHARGE_POINTS_FAIL]:
    fetchAlertChargePointsFail,
  [OperatorsAlertTypes.SET_ALERT_CHARGE_POINTS_FILTER]:
    setAlertChargePointsFilter,
  [OperatorsAlertTypes.RESET_ALERT_CHARGE_POINTS]: resetAlertChargePoints,
  [OperatorsAlertTypes.EDIT_ALERT_LOADING]: editAlertLoading,
  [OperatorsAlertTypes.EDIT_ALERT_SUCCESS]: editAlertSuccess,
  [OperatorsAlertTypes.EDIT_ALERT_FAIL]: editAlertFail,
  [OperatorsAlertTypes.DELETE_ALERT_LOADING]: deleteAlertLoading,
  [OperatorsAlertTypes.DELETE_ALERT_SUCCESS]: deleteAlertSuccess,
  [OperatorsAlertTypes.DELETE_ALERT_FAIL]: deleteAlertFail,
  [OperatorsAlertTypes.CREATE_ALERT_LOADING]: createAlertLoading,
  [OperatorsAlertTypes.CREATE_ALERT_SUCCESS]: createAlertSuccess,
  [OperatorsAlertTypes.CREATE_ALERT_FAIL]: createAlertFail,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_COUNT_LOADING]:
    fetchOperatorsAlertsCountLoading,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_COUNT_SUCCESS]:
    fetchOperatorsAlertsCountSuccess,
  [OperatorsAlertTypes.FETCH_OPERATORS_ALERTS_COUNT_FAIL]:
    fetchOperatorsAlertsCountFail,
  [OperatorsAlertTypes.SET_OPERATOR_ALERT_FILTER]: setOperatorAlertFilter,
  [OperatorsAlertTypes.CLEAR_OPERATOR_ALERTS]: clearOperatorAlerts,
  [OperatorsAlertTypes.RESET_EDITING_STATES]: resetEditingStates,
})
